import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class DashboardsPaths {
  static dashboards = new EnhancedPath('/dashboards');
}

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: DashboardsPaths.dashboards.path,
      component: lazyWithRetry(() => import('app/pages/dashboards')),
    },
  ],
};

export default routesConfig;
